/*
 * AUTO-GENERATED FILE. DO NOT EDIT.
 *
 * Source: robot_compiler/viewer/protocol.py
 * Source: robot_compiler/viewer/message_router.py (client->server routes)
 * Generator: tools/generate_protocol_types.py
 */

import type {
  GuiEventMessage,
  TransformEventMessage,
  ClickEventMessage,
  AddModuleMessage,
  PreviewConnectionMessage,
  ConnectModulesMessage,
  SelectInstanceMessage,
  UpdateInstancePositionMessage,
  TranslationEndMessage,
  DeleteInstanceMessage,
  DisconnectInstanceMessage,
  ClearAllInstancesMessage,
  SetInstancePrefixMessage,
  SetInstanceParameterMessage,
  EnableIKModeMessage,
  EnableSelfCollisionMessage,
  EnableJointAxesMessage,
  SetJointAxisReversedMessage,
  EnterEditModuleAxesMessage,
  SaveModuleAxesMessage,
  IKGizmoUpdateMessage,
  SetIKConstraintsMessage,
  JointSliderUpdateMessage,
  ExportUrdfMessage,
  SaveConfigMessage,
  LoadConfigMessage,
  EnterEditLinksMessage,
  ExitEditLinksMessage,
  SaveConnectableLinksMessage,
  AddEndCoordsMessage,
  UpdateEndCoordsMessage,
  DeleteEndCoordsMessage,
  HighlightInstanceMessage,
  ShowEndCoordsGizmoMessage,
  EndCoordsGizmoUpdateMessage,
  RenameJointMessage,
  CreateJointGroupMessage,
  UpdateJointGroupMessage,
  DeleteJointGroupMessage,
  DetectKinematicChainsMessage,
  UpdateJointSettingsMessage,
  UpdateLocomotionMessage,
  UpdateMimicSettingsMessage,
  HighlightJointMessage,
  GetChainJointsMessage,
  GetUrdfForConfigMessage,
  UploadModuleMessage,
} from "./protocol.generated";

export type ClientMessage =
  | GuiEventMessage
  | TransformEventMessage
  | ClickEventMessage
  | AddModuleMessage
  | PreviewConnectionMessage
  | ConnectModulesMessage
  | SelectInstanceMessage
  | UpdateInstancePositionMessage
  | TranslationEndMessage
  | DeleteInstanceMessage
  | DisconnectInstanceMessage
  | ClearAllInstancesMessage
  | SetInstancePrefixMessage
  | SetInstanceParameterMessage
  | EnableIKModeMessage
  | EnableSelfCollisionMessage
  | EnableJointAxesMessage
  | SetJointAxisReversedMessage
  | EnterEditModuleAxesMessage
  | SaveModuleAxesMessage
  | IKGizmoUpdateMessage
  | SetIKConstraintsMessage
  | JointSliderUpdateMessage
  | ExportUrdfMessage
  | SaveConfigMessage
  | LoadConfigMessage
  | EnterEditLinksMessage
  | ExitEditLinksMessage
  | SaveConnectableLinksMessage
  | AddEndCoordsMessage
  | UpdateEndCoordsMessage
  | DeleteEndCoordsMessage
  | HighlightInstanceMessage
  | ShowEndCoordsGizmoMessage
  | EndCoordsGizmoUpdateMessage
  | RenameJointMessage
  | CreateJointGroupMessage
  | UpdateJointGroupMessage
  | DeleteJointGroupMessage
  | DetectKinematicChainsMessage
  | UpdateJointSettingsMessage
  | UpdateLocomotionMessage
  | UpdateMimicSettingsMessage
  | HighlightJointMessage
  | GetChainJointsMessage
  | GetUrdfForConfigMessage
  | UploadModuleMessage
;

export function guiEvent(
  fields: Omit<GuiEventMessage, "type">
): GuiEventMessage {
  return { type: "gui_event", ...fields };
}

export function transformEvent(
  fields: Omit<TransformEventMessage, "type">
): TransformEventMessage {
  return { type: "transform_event", ...fields };
}

export function clickEvent(
  fields: Omit<ClickEventMessage, "type">
): ClickEventMessage {
  return { type: "click_event", ...fields };
}

export function addModule(
  fields: Omit<AddModuleMessage, "type">
): AddModuleMessage {
  return { type: "add_module", ...fields };
}

export function previewConnection(
  fields: Omit<PreviewConnectionMessage, "type">
): PreviewConnectionMessage {
  return { type: "preview_connection", ...fields };
}

export function connectModules(
  fields: Omit<ConnectModulesMessage, "type">
): ConnectModulesMessage {
  return { type: "connect_modules", ...fields };
}

export function selectInstance(
  fields: Omit<SelectInstanceMessage, "type">
): SelectInstanceMessage {
  return { type: "select_instance", ...fields };
}

export function updateInstancePosition(
  fields: Omit<UpdateInstancePositionMessage, "type">
): UpdateInstancePositionMessage {
  return { type: "update_instance_position", ...fields };
}

export function translationEnd(): TranslationEndMessage {
  return { type: "translation_end" };
}

export function deleteInstance(
  fields: Omit<DeleteInstanceMessage, "type">
): DeleteInstanceMessage {
  return { type: "delete_instance", ...fields };
}

export function disconnectInstance(
  fields: Omit<DisconnectInstanceMessage, "type">
): DisconnectInstanceMessage {
  return { type: "disconnect_instance", ...fields };
}

export function clearAllInstances(): ClearAllInstancesMessage {
  return { type: "clear_all_instances" };
}

export function setInstancePrefix(
  fields: Omit<SetInstancePrefixMessage, "type">
): SetInstancePrefixMessage {
  return { type: "set_instance_prefix", ...fields };
}

export function setInstanceParameter(
  fields: Omit<SetInstanceParameterMessage, "type">
): SetInstanceParameterMessage {
  return { type: "set_instance_parameter", ...fields };
}

export function enableIkMode(
  fields: Omit<EnableIKModeMessage, "type">
): EnableIKModeMessage {
  return { type: "enable_ik_mode", ...fields };
}

export function enableSelfCollision(
  fields: Omit<EnableSelfCollisionMessage, "type">
): EnableSelfCollisionMessage {
  return { type: "enable_self_collision", ...fields };
}

export function enableJointAxes(
  fields: Omit<EnableJointAxesMessage, "type">
): EnableJointAxesMessage {
  return { type: "enable_joint_axes", ...fields };
}

export function setJointAxisReversed(
  fields: Omit<SetJointAxisReversedMessage, "type">
): SetJointAxisReversedMessage {
  return { type: "set_joint_axis_reversed", ...fields };
}

export function enterEditModuleAxes(
  fields: Omit<EnterEditModuleAxesMessage, "type">
): EnterEditModuleAxesMessage {
  return { type: "enter_edit_module_axes", ...fields };
}

export function saveModuleAxes(
  fields: Omit<SaveModuleAxesMessage, "type">
): SaveModuleAxesMessage {
  return { type: "save_module_axes", ...fields };
}

export function ikGizmoUpdate(
  fields: Omit<IKGizmoUpdateMessage, "type">
): IKGizmoUpdateMessage {
  return { type: "ik_gizmo_update", ...fields };
}

export function setIkConstraints(
  fields: Omit<SetIKConstraintsMessage, "type">
): SetIKConstraintsMessage {
  return { type: "set_ik_constraints", ...fields };
}

export function jointSliderUpdate(
  fields: Omit<JointSliderUpdateMessage, "type">
): JointSliderUpdateMessage {
  return { type: "joint_slider_update", ...fields };
}

export function exportUrdf(
  fields: Omit<ExportUrdfMessage, "type">
): ExportUrdfMessage {
  return { type: "export_urdf", ...fields };
}

export function saveConfig(
  fields: Omit<SaveConfigMessage, "type">
): SaveConfigMessage {
  return { type: "save_config", ...fields };
}

export function loadConfig(
  fields: Omit<LoadConfigMessage, "type">
): LoadConfigMessage {
  return { type: "load_config", ...fields };
}

export function enterEditLinksMode(
  fields: Omit<EnterEditLinksMessage, "type">
): EnterEditLinksMessage {
  return { type: "enter_edit_links_mode", ...fields };
}

export function exitEditLinksMode(): ExitEditLinksMessage {
  return { type: "exit_edit_links_mode" };
}

export function saveConnectableLinks(
  fields: Omit<SaveConnectableLinksMessage, "type">
): SaveConnectableLinksMessage {
  return { type: "save_connectable_links", ...fields };
}

export function addEndCoords(
  fields: Omit<AddEndCoordsMessage, "type">
): AddEndCoordsMessage {
  return { type: "add_end_coords", ...fields };
}

export function updateEndCoords(
  fields: Omit<UpdateEndCoordsMessage, "type">
): UpdateEndCoordsMessage {
  return { type: "update_end_coords", ...fields };
}

export function deleteEndCoords(
  fields: Omit<DeleteEndCoordsMessage, "type">
): DeleteEndCoordsMessage {
  return { type: "delete_end_coords", ...fields };
}

export function highlightInstance(
  fields: Omit<HighlightInstanceMessage, "type">
): HighlightInstanceMessage {
  return { type: "highlight_instance", ...fields };
}

export function showEndCoordsGizmo(
  fields: Omit<ShowEndCoordsGizmoMessage, "type">
): ShowEndCoordsGizmoMessage {
  return { type: "show_end_coords_gizmo", ...fields };
}

export function endCoordsGizmoUpdate(
  fields: Omit<EndCoordsGizmoUpdateMessage, "type">
): EndCoordsGizmoUpdateMessage {
  return { type: "end_coords_gizmo_update", ...fields };
}

export function renameJoint(
  fields: Omit<RenameJointMessage, "type">
): RenameJointMessage {
  return { type: "rename_joint", ...fields };
}

export function createJointGroup(
  fields: Omit<CreateJointGroupMessage, "type">
): CreateJointGroupMessage {
  return { type: "create_joint_group", ...fields };
}

export function updateJointGroup(
  fields: Omit<UpdateJointGroupMessage, "type">
): UpdateJointGroupMessage {
  return { type: "update_joint_group", ...fields };
}

export function deleteJointGroup(
  fields: Omit<DeleteJointGroupMessage, "type">
): DeleteJointGroupMessage {
  return { type: "delete_joint_group", ...fields };
}

export function detectKinematicChains(): DetectKinematicChainsMessage {
  return { type: "detect_kinematic_chains" };
}

export function updateJointSettings(
  fields: Omit<UpdateJointSettingsMessage, "type">
): UpdateJointSettingsMessage {
  return { type: "update_joint_settings", ...fields };
}

export function updateLocomotion(
  fields: Omit<UpdateLocomotionMessage, "type">
): UpdateLocomotionMessage {
  return { type: "update_locomotion", ...fields };
}

export function updateMimicSettings(
  fields: Omit<UpdateMimicSettingsMessage, "type">
): UpdateMimicSettingsMessage {
  return { type: "update_mimic_settings", ...fields };
}

export function highlightJoint(
  fields: Omit<HighlightJointMessage, "type">
): HighlightJointMessage {
  return { type: "highlight_joint", ...fields };
}

export function getChainJoints(
  fields: Omit<GetChainJointsMessage, "type">
): GetChainJointsMessage {
  return { type: "get_chain_joints", ...fields };
}

export function getUrdfForConfig(): GetUrdfForConfigMessage {
  return { type: "get_urdf_for_config" };
}

export function uploadModule(
  fields: Omit<UploadModuleMessage, "type">
): UploadModuleMessage {
  return { type: "upload_module", ...fields };
}
